
import React, { useState } from "react";
import {
    Trophy,
    Clock,
    ChevronUp,
    ChevronDown,
    User,
    Target,

} from "lucide-react";
const LiveScoreCard = () => {
    const [showScoreboard, setShowScoreboard] = useState(false);
    return (
        <div className="mb-6">
            <div className="rounded-xl border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 shadow-lg overflow-hidden">

                {/* Header */}
                <div className="p-6 pb-3">
                    <div className="flex flex-col sm:flex-row justify-between gap-4">

                        {/* Left */}
                        <div className="flex items-center gap-2">
                            <Trophy className="w-5 h-5 text-blue-600" />
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                Live Score
                            </h3>
                        </div>

                        {/* Right */}
                        <div className="flex items-center gap-3 flex-wrap">

                            <span className="px-3 py-1 rounded-full bg-green-100 dark:bg-green-900 text-green-600 text-xs font-medium">
                                Completed
                            </span>

                            <div className="flex items-center gap-1 text-xs text-gray-500">
                                <Clock className="w-3 h-3" />
                                3:12:02 PM
                            </div>

                        </div>

                    </div>
                </div>

                {/* Team Score Cards */}
                <div className="p-6 pt-2">

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                        {/* CSK */}
                        <div className="flex flex-col items-center p-4 rounded-xl border bg-gray-50 dark:bg-zinc-800 dark:border-zinc-700">

                            <img
                                src="https://i.ibb.co.com/N6whpVTs/Chennai-Super-Kings-Logo-svg.png"
                                alt="CSK"
                                className="w-14 h-14 object-contain"
                            />

                            <h4 className="font-medium mt-2 text-center dark:text-white">
                                Chennai Super Kings
                            </h4>

                            <div className="mt-2 flex items-end gap-1">
                                <span className="text-3xl font-bold text-blue-600">
                                    180/7
                                </span>

                                <span className="text-xs text-gray-500">
                                    (20 ov)
                                </span>
                            </div>

                        </div>


                        {/* SRH */}
                        <div className="flex flex-col items-center p-4 rounded-xl border bg-gray-50 dark:bg-zinc-800 dark:border-zinc-700">

                            <img
                                src="https://i.ibb.co.com/wh7pKKZ2/Sunrisers-Hyderabad-Logo-svg.png"
                                alt="SRH"
                                className="w-14 h-14 object-contain"
                            />

                            <h4 className="font-medium mt-2 text-center dark:text-white">
                                Sunrisers Hyderabad
                            </h4>

                            <div className="mt-2 flex items-end gap-1">
                                <span className="text-3xl font-bold text-blue-600">
                                    181/5
                                </span>

                                <span className="text-xs text-gray-500">
                                    (19 ov)
                                </span>
                            </div>

                        </div>

                    </div>

                    {/* Match Result */}
                    <div className="mt-4 bg-blue-50 dark:bg-blue-950 p-3 rounded-lg text-center">

                        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            SRH won by 5 wickets (with 6 balls remaining)
                        </p>

                    </div>

                    {/* Status */}
                    <div className="mt-4 flex justify-center">
                        <span className="px-3 py-1 rounded-full border text-xs dark:border-zinc-700 dark:text-gray-300">
                            Finished
                        </span>
                    </div>

                </div>

                <div className="p-6 pt-2">
                    {/* Expand Button */}

                    <div className="mt-4">

                        <button
                            onClick={() => setShowScoreboard(!showScoreboard)}
                            className="w-full flex items-center justify-between p-3 rounded-lg border
    dark:border-zinc-700
    hover:bg-gray-100
    dark:hover:bg-zinc-800
    transition"
                        >

                            <div className="flex items-center gap-2">

                                <Trophy className="w-4 h-4" />

                                <span className="text-sm font-medium dark:text-white">
                                    {showScoreboard
                                        ? "Hide Full Scoreboard"
                                        : "Show Full Scoreboard"}
                                </span>

                            </div>

                            {showScoreboard ? (
                                <ChevronUp className="w-4 h-4" />
                            ) : (
                                <ChevronDown className="w-4 h-4" />
                            )}

                        </button>

                    </div>


                    {/* Expandable Area */}

                    {showScoreboard && (

                        <div className="mt-5 border-t pt-5 dark:border-zinc-700">

                            {/* Venue */}
                            <div className="space-y-2">

                                <p className="text-center text-sm text-gray-500">

                                    Venue:
                                    MA Chidambaram Stadium,
                                    Chepauk,
                                    Chennai

                                </p>

                                <p className="text-center text-xs text-gray-400">

                                    Chennai Super Kings elected to bat first

                                </p>

                            </div>


                            {/* Tabs */}

                            <div className="grid grid-cols-2 mt-5 bg-gray-100 dark:bg-zinc-800 rounded-lg p-1">

                                <button
                                    className="
        bg-blue-600
        text-white
        rounded-md
        py-2
        text-sm
        font-medium"
                                >
                                    Chennai Super Kings
                                </button>

                                <button
                                    className="
        rounded-md
        py-2
        text-sm
        dark:text-gray-300"
                                >
                                    Sunrisers Hyderabad
                                </button>

                            </div>

                            {/* Batting Section */}

                            <div className="mt-6 space-y-4">

                                {/* Header */}
                                <div className="flex items-center justify-between flex-wrap gap-2">

                                    <div className="flex items-center gap-2">

                                        <User className="w-4 h-4 text-blue-600" />

                                        <span className="font-semibold text-sm dark:text-white">
                                            Batting
                                        </span>

                                        <span
                                            className="
        px-2 py-1
        text-[10px]
        rounded-full
        border
        dark:border-zinc-700"
                                        >
                                            1 INN
                                        </span>

                                    </div>

                                    <span className="text-sm font-bold text-blue-600">
                                        180/7 (20 ov)
                                    </span>

                                </div>


                                {/* Table */}

                                <div className="rounded-xl border dark:border-zinc-700 overflow-hidden">

                                    <div className="overflow-x-auto">

                                        <table className="min-w-full text-sm">

                                            <thead className="bg-gray-100 dark:bg-zinc-800">

                                                <tr>

                                                    <th className="px-3 py-3 text-left text-xs">
                                                        Batter
                                                    </th>

                                                    <th className="px-2 py-3 text-right text-xs">
                                                        R
                                                    </th>

                                                    <th className="px-2 py-3 text-right text-xs">
                                                        B
                                                    </th>

                                                    <th className="px-2 py-3 text-right text-xs">
                                                        4s
                                                    </th>

                                                    <th className="px-2 py-3 text-right text-xs">
                                                        6s
                                                    </th>

                                                    <th className="px-2 py-3 text-right text-xs">
                                                        SR
                                                    </th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {[
                                                    {
                                                        player: "Sanju Samson",
                                                        out: "c Ishan Kishan b Cummins",
                                                        r: 27,
                                                        b: 13,
                                                        f: 5,
                                                        s: 1,
                                                        sr: 207.69
                                                    },

                                                    {
                                                        player: "Ruturaj Gaikwad",
                                                        out: "c Malinga b Cummins",
                                                        r: 15,
                                                        b: 21,
                                                        f: 0,
                                                        s: 0,
                                                        sr: 71.42
                                                    },

                                                    {
                                                        player: "Urvil Patel",
                                                        out: "b Sakib Hussain",
                                                        r: 13,
                                                        b: 8,
                                                        f: 0,
                                                        s: 2,
                                                        sr: 162.5
                                                    },

                                                    {
                                                        player: "Kartik Sharma",
                                                        out: "c Nitish Kumar b Cummins",
                                                        r: 32,
                                                        b: 19,
                                                        f: 3,
                                                        s: 2,
                                                        sr: 168.42
                                                    },

                                                    {
                                                        player: "Dewald Brevis",
                                                        out: "b Malinga",
                                                        r: 44,
                                                        b: 27,
                                                        f: 2,
                                                        s: 4,
                                                        sr: 162.96
                                                    },

                                                    {
                                                        player: "Akeal Hosein",
                                                        out: "not out",
                                                        r: 3,
                                                        b: 1,
                                                        f: 0,
                                                        s: 0,
                                                        sr: 300
                                                    }

                                                ].map((item, index) => (

                                                    <tr
                                                        key={index}
                                                        className="
              border-t
              dark:border-zinc-700
              hover:bg-gray-50
              dark:hover:bg-zinc-800"
                                                    >

                                                        <td className="px-3 py-3">

                                                            <div className="flex flex-col">

                                                                <span className="font-medium text-xs dark:text-white">
                                                                    {item.player}
                                                                </span>

                                                                <span
                                                                    className={`
                    text-[10px]
                    ${item.out === "not out"
                                                                            ? "text-green-500"
                                                                            : "text-gray-500"
                                                                        }`}
                                                                >
                                                                    {item.out}
                                                                </span>

                                                            </div>

                                                        </td>

                                                        <td className="text-right px-2 font-semibold">
                                                            {item.r}
                                                        </td>

                                                        <td className="text-right px-2">
                                                            {item.b}
                                                        </td>

                                                        <td className="text-right px-2">
                                                            {item.f}
                                                        </td>

                                                        <td className="text-right px-2">
                                                            {item.s}
                                                        </td>

                                                        <td className="text-right px-2">
                                                            {item.sr}
                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>


                                {/* Did Not Bat */}

                                <div className="bg-gray-50 dark:bg-zinc-800 p-3 rounded-lg">

                                    <span className="text-xs font-medium">
                                        Did Not Bat:
                                    </span>

                                    <span className="text-xs text-gray-500 ml-2">

                                        Mukesh Choudhary,
                                        Noor Ahmad,
                                        Anshul Kamboj,
                                        Spencer Johnson

                                    </span>

                                </div>

                                {/* Bowling Section */}

                                <div className="mt-6 space-y-4">

                                    {/* Header */}

                                    <div className="flex items-center gap-2">

                                        <Target className="w-4 h-4 text-blue-600" />

                                        <span className="font-semibold text-sm dark:text-white">
                                            Bowling
                                        </span>

                                    </div>


                                    {/* Table */}

                                    <div className="rounded-xl border dark:border-zinc-700 overflow-hidden">

                                        <div className="overflow-x-auto">

                                            <table className="min-w-full text-sm">

                                                <thead className="bg-gray-100 dark:bg-zinc-800">

                                                    <tr>

                                                        <th className="px-3 py-3 text-left text-xs">
                                                            Bowler
                                                        </th>

                                                        <th className="px-2 py-3 text-right text-xs">
                                                            O
                                                        </th>

                                                        <th className="px-2 py-3 text-right text-xs">
                                                            M
                                                        </th>

                                                        <th className="px-2 py-3 text-right text-xs">
                                                            R
                                                        </th>

                                                        <th className="px-2 py-3 text-right text-xs">
                                                            W
                                                        </th>

                                                        <th className="px-2 py-3 text-right text-xs">
                                                            Econ
                                                        </th>

                                                    </tr>

                                                </thead>


                                                <tbody>

                                                    {[
                                                        {
                                                            name: "Nitish Kumar Reddy",
                                                            o: "2.0",
                                                            m: 0,
                                                            r: 35,
                                                            w: 0,
                                                            e: "17.50"
                                                        },

                                                        {
                                                            name: "Praful Hinge",
                                                            o: "3.0",
                                                            m: 0,
                                                            r: 37,
                                                            w: 1,
                                                            e: "12.33"
                                                        },

                                                        {
                                                            name: "Pat Cummins",
                                                            o: "4.0",
                                                            m: 0,
                                                            r: 28,
                                                            w: 3,
                                                            e: "7.00"
                                                        },

                                                        {
                                                            name: "Eshan Malinga",
                                                            o: "4.0",
                                                            m: 0,
                                                            r: 26,
                                                            w: 1,
                                                            e: "6.50"
                                                        },

                                                        {
                                                            name: "Sakib Hussain",
                                                            o: "4.0",
                                                            m: 0,
                                                            r: 34,
                                                            w: 2,
                                                            e: "8.50"
                                                        },

                                                        {
                                                            name: "Shivang Kumar",
                                                            o: "3.0",
                                                            m: 0,
                                                            r: 20,
                                                            w: 0,
                                                            e: "6.66"
                                                        }

                                                    ].map((bowler, index) => (

                                                        <tr
                                                            key={index}
                                                            className="
              border-t
              dark:border-zinc-700
              hover:bg-gray-50
              dark:hover:bg-zinc-800
              transition"
                                                        >

                                                            <td className="px-3 py-3">

                                                                <span className="text-xs font-medium dark:text-white">

                                                                    {bowler.name}

                                                                </span>

                                                            </td>

                                                            <td className="text-right px-2 text-xs">
                                                                {bowler.o}
                                                            </td>

                                                            <td className="text-right px-2 text-xs">
                                                                {bowler.m}
                                                            </td>

                                                            <td className="text-right px-2 text-xs">
                                                                {bowler.r}
                                                            </td>

                                                            <td className="text-right px-2 font-semibold text-xs">
                                                                {bowler.w}
                                                            </td>

                                                            <td className="text-right px-2 text-xs">
                                                                {bowler.e}
                                                            </td>

                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </table>

                                        </div>

                                    </div>

                                </div>


                                {/* Last Updated Footer */}

                                <div
                                    className="
  mt-6
  pt-4
  border-t
  dark:border-zinc-700
  flex
  justify-center
  items-center
  gap-2
  text-xs
  text-gray-500"
                                >

                                    <Clock className="w-3 h-3" />

                                    <span>
                                        Last updated: 3:12:02 PM
                                    </span>

                                </div>
                                

                            </div>


                        </div>

                    )}
                </div>

            </div>
        </div>
    );
};

export default LiveScoreCard;